/* This is a mst-gql generated file, don't modify it manually */
 

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"


/**
 * ReservationUnavailableBase
 * auto generated base class for the model ReservationUnavailableModel.
 */
export const ReservationUnavailableModelBase = ModelBase
  .named('ReservationUnavailable')
  .props({
    __typename: types.optional(types.literal("ReservationUnavailable"), "ReservationUnavailable"),
    message: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore()
    }
  }))

export class ReservationUnavailableModelSelector extends QueryBuilder {
  get message() { return this.__attr(`message`) }
}
export function selectFromReservationUnavailable() {
  return new ReservationUnavailableModelSelector()
}

export const reservationUnavailableModelPrimitives = selectFromReservationUnavailable().message
